import * as React from 'react'
import { CountryContext } from '../context/CountryContext'

const useCountryContext = () => {
    return React.useContext(CountryContext)
}

export default useCountryContext
